import type { StoryblokRichTextNode } from "@storyblok/vue";
import { NuxtLink } from "#components";

const getAttrHref = (node: StoryblokRichTextNode) => {
  if (!node.attrs) {
    return "!#";
  }

  const isEmailLinkType = (type: string) => type === "email";
  const isUrlLinkType = (type: string) => ["url", "story"].includes(type);

  const escapeHTML = function (str: string) {
    const htmlEscapes: { [key: string]: string } = {
      "&": "&amp;",
      "<": "&lt;",
      ">": "&gt;",
      '"': "&quot;",
      "'": "&#39;",
    };

    const reUnescapedHtml = /[&<>"']/g;
    const reHasUnescapedHtml = RegExp(reUnescapedHtml.source);

    return str && reHasUnescapedHtml.test(str) ? str.replace(reUnescapedHtml, (chr) => htmlEscapes[chr]) : str;
  };
  const attrs = { ...node.attrs };
  const { linktype = "url" } = node.attrs;
  delete attrs.linktype;

  if (isEmailLinkType(linktype)) {
    attrs.href = `mailto:${attrs.href}`;
  } else if (isUrlLinkType(linktype)) {
    if (attrs.href) {
      attrs.href = escapeHTML(node.attrs.href || "");

      if (!attrs.href.startsWith("http://") && !attrs.href.startsWith("https://") && !attrs.href.startsWith("mailto:") && !attrs.href.startsWith("tel:")) {
        attrs.href = "/" + attrs.href.replace(/^\/+/, "");
      }
    }
  }

  if (attrs.anchor) {
    attrs.href = `${attrs.href}#${attrs.anchor}`;
    delete attrs.anchor;
  }

  if (attrs.custom) {
    for (const key in attrs.custom) {
      attrs[key] = attrs.custom[key];
    }
    delete attrs.custom;
  }

  return attrs.href;
};

export default {
  [MarkTypes.LINK]: (node: StoryblokRichTextNode<VNode>) =>
    h(
      NuxtLink,
      {
        to: getAttrHref(node),
        target: node.attrs?.target,
      },
      () => node.text
    ),
};
